import { FormBase } from 'core/components';

export default class LabelingModeForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'pallet',
					label: 'FULFILLMENTORDER.LABELINGMODE.PALLET',
					rules: 'required' 
				},
				{
					name: 'upc',
					label: 'FULFILLMENTORDER.LABELINGMODE.UPC',
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.LABELINGMODE.TRACKINGNUMBER',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/LabelingModeForm.js